<template>
  <div class="overlay-full-screen" ref="overlay" data-animate="overlay">
    <div
      class="overlay-full-screen__background"
      data-animate="overlay-background"
    />
    <div class="overlay-full-screen__content" data-animate="overlay-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetOverlayFullScreen',
}
</script>

<script setup>
import { gsap } from 'gsap'

const emit = defineEmits(['animation-update', 'animation-reverse-complete'])

const props = defineProps({
  show: Boolean,
})

const overlay = ref(null)
const tl = ref(null)

watch(
  () => props.show,
  async (show) => {
    if (!tl.value?.isActive()) {
      tl.value = show ? animateIn() : animateOut()
      await tl.value.play()
    }
  }
)

// Animazioni
const animateIn = (params) => {
  const parent = overlay.value
  const background = parent.querySelector('[data-animate="overlay-background"]')
  const content = parent.querySelector('[data-animate="overlay-content"]')

  const tl = gsap.timeline({
    paused: true,
    onUpdate: () => {
      emit('animation-update', tl.progress())
    },
    onComplete: () => {
      tl.kill()
    },
    ...params,
  })

  tl.set(parent, { autoAlpha: 1 })
  tl.set(document.body, { overflow: 'hidden' })
  tl.to(background, {
    scaleX: 1,
  })
  tl.to(content, {
    opacity: 1,
  })

  return tl
}

const animateOut = (params) => {
  const parent = overlay.value
  const background = parent.querySelector('[data-animate="overlay-background"]')
  const content = parent.querySelector('[data-animate="overlay-content"]')

  const tl = gsap.timeline({
    paused: true,
    onComplete: () => {
      emit('animation-reverse-complete')
      tl.kill()
      gsap.set([parent, background, content], {
        clearProps: 'all',
      })
    },
    ...params,
  })
  tl.to(content, {
    opacity: 0,
  })
  tl.to(background, {
    scaleX: 0,
  })
  tl.set(document.body, { overflow: 'auto' })

  tl.set(parent, { autoAlpha: 0 })

  return tl
}

defineExpose({
  animateIn,
  animateOut,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
